import React from 'react';
import InputField from '../../Forms/Input/InputField';
import { ProductFormValues } from '../../../types/product/ProductFormValues';
import { useProduct } from '../../../hooks/useProduct';

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductExternalIdentifiersSection: React.FC<Props> = ({
  form,
  onChange,
}) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <InputField
        label="Código de Barras:"
        name="barcode"
        type="text"
        iconKey="barcode"
        value={form.barcode ?? ''}
        onChange={(e) => onChange('barcode', e.target.value)}
        placeholder="Escanee o escriba el código de barras"
        error={formErrors.barcode}
      />

      <InputField
        label="SKU:"
        name="sku"
        type="text"
        iconKey="tag"
        value={form.sku ?? ''}
        onChange={(e) => onChange('sku', e.target.value)}
        placeholder="Código interno del inventario"
        error={formErrors.sku}
      />

      <InputField
        label="Código de Fabricante:"
        name="manufacturerCode"
        type="text"
        iconKey="id"
        value={form.manufacturerCode ?? ''}
        onChange={(e) => onChange('manufacturerCode', e.target.value)}
        placeholder="Referencia del proveedor"
        error={formErrors.manufacturerCode}
      />

      <InputField
        label="Código de Búsqueda:"
        name="searchCode"
        type="text"
        iconKey="search"
        value={form.searchCode ?? ''}
        onChange={(e) => onChange('searchCode', e.target.value)}
        placeholder="Código rápido para búsqueda"
        error={formErrors.searchCode}
      />
    </div>
  );
};

export default ProductExternalIdentifiersSection;
